import { Card, CardContent, CardMedia, Typography, Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock"; // 錠前アイコン
import QuestClearedChip from "./QuestClearedChip";

export default function QuestCard({ quest, onClick }) {
  return (
    <Card
      sx={(theme) => ({
        display: "flex",
        maxWidth: 600,
        width: "100%",
        position: "relative",
        overflow: "hidden",
        ...theme.components.questCard.paper,
      })}
      onClick={onClick}
    >
      {quest.is_locked && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // 黒い透明レイヤー
            backdropFilter: "blur(16px)", // ここで背景をぼかす
            WebkitBackdropFilter: "blur(16px)", // Safari対応
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1, // レイヤーを上に配置
          }}
        >
          <LockIcon
            sx={(theme) => ({
              fontSize: 50,
              ...theme.components.questCard.lockIcon,
            })}
          />
        </div>
      )}
      <CardMedia
        component="img"
        sx={{ width: "50%", maxWidth: 200, minHeight: 160, objectFit: "cover" }}
        image={quest.eye_catch_url}
        alt="Image description"
      />
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 2,
          flex: 1,
        }}
      >
        <Typography
          sx={(theme) => ({
            ...theme.components.questCard.text.name,
          })}
        >
          {quest.name}
        </Typography>

        <Typography
          variant="h6"
          sx={(theme) => ({
            textAlign: "center",
            mt: 1,
            ...theme.components.questCard.text.description,
          })}
        >
          {quest.description}
        </Typography>

        {(!quest.is_expired || quest.is_cleared) && (
          <Box mt={2}>
            <QuestClearedChip isCleared={quest.is_cleared} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
}
